module.exports = __webpack_public_path__ + "img/canada-blood-diseases-female.f888d3c1.png";